<template>
    <section class="bg--white m-0 position-relative no-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="main col-12">
                    <validation-observer ref="form">
                        <form action="" class="row">
                            <div class="form-section w-100">
                                <h2 class="heading-spacing--large pb-2">
                                    Adviseur CEG
                                </h2>
                                <div class="row">
                                    <text-input
                                        v-model="
                                            profileUpdate.ContactPersonFirstname
                                        "
                                        class="col-12 col-md-6"
                                        name="Voornaam"
                                        rules="required"
                                    />
                                    <text-input
                                        v-model="
                                            profileUpdate.ContactPersonPhoneNumber
                                        "
                                        class="col-12 col-md-6"
                                        name="Telefoon adviseur"
                                        rules="required|digits:10"
                                        @input="updateCegInformation"
                                    />
                                    <text-input
                                        v-model="
                                            profileUpdate.ContactPersonInsertion
                                        "
                                        class="col-12 col-md-6"
                                        name="Tussenvoegsel"
                                        @input="updateCegInformation"
                                    />
                                    <text-input
                                        v-model="
                                            profileUpdate.ContactPersonLastname
                                        "
                                        class="col-12 col-md-6"
                                        name="Achternaam"
                                        rules="required"
                                        @input="updateCegInformation"
                                    />
                                </div>
                            </div>

                            <div class="form-section col-12 w-100">
                                <h2 class="heading-spacing--medium pb-2">
                                    Gekoppelde scholen
                                </h2>
                                <div class="row">
                                    <v-data-table
                                        :headers="headers"
                                        :items="schools"
                                        class="elevation-1 col-12"
                                        disable-pagination
                                    ></v-data-table>
                                </div>
                            </div>

                            <editPassword
                                :profile="profileUpdate"
                                class="col-12 col-md-6 login-small"
                                @input="updateCegInformation"
                            />
                            <dashboardMessage
                                :message="responseMsg"
                                :process="processing"
                            />
                        </form>
                    </validation-observer>
                </div>
            </div>
        </div>
        <error-bar v-if="errorMessage" :error-message="errorMessage" />
    </section>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { initVeeValidate } from '@/plugins/vee-validate';
import textInput from '@/components/form/text-input';
import editPassword from '@/components/form/edit-password';
import errorBar from '@/components/clientdashboard/dashboard-profile/error-bar';
import dashboardMessage from '@/components/clientdashboard/dashboard-profile/clientdashboard-profile-message';
import Axios from 'axios';

initVeeValidate();

export default {
    components: {
        ValidationObserver,
        textInput,
        editPassword,
        errorBar,
        dashboardMessage
    },
    props: {
        profile: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            responseMsg: '',
            error: false,
            errorMessage: '',
            validationError: false,
            success: false,
            submitted: false,
            processing: false,
            profileUpdate: {
                id: '',
                name: '',
                brin: '',
                locationNumber: '',
                schoolLogo: '',
                street: '',
                housenumber: '',
                zipcode: '',
                city: '',
                phone: '',
                email: '',
                newUserName: '',
                password: '',
                passwordRepeat: '',
                contactPersonFirstname: '',
                contactPersonInsertion: '',
                contactPersonLastname: '',
                contactPersonPhone: '',
                contactPersonEmail: ''
            },
            schools: [],
            headers: [
                { text: 'Schoolnaam', value: 'SchoolName' },
                { text: 'E-mailadres', value: 'Email' },
                { text: 'Gemeente', value: 'SchoolMunicipality' }
            ]
        };
    },
    computed: {},
    created() {
        this.profileUpdate = this.profile;
    },
    mounted() {
        this.schools = this.profile.Schools;
    },
    methods: {
        updateCegInformation() {
            this.submitted = true;
            this.processing = true;
            this.responseMsg = '';
            const self = this;

            this.$refs.form.validate().then(success => {
                if (success) {
                    Axios.post(
                        '/clientdashboard/ceg/update',
                        self.profileUpdate
                    )
                        .then(response => {
                            self.response = response;
                            self.processing = false;
                            self.submitted = false;
                            self.error = false;
                            if (response.data.success) {
                                self.responseMsg = response.data.successMsg;
                                self.profileUpdate.Password = null;
                                self.profileUpdate.PasswordRepeat = null;
                            } else {
                                self.errorMessage = response.data.errorMsg;
                            }
                            setTimeout(function() {
                                self.responseMsg = '';
                                self.errorMessage = '';
                            }, 5000);
                            return;
                        })
                        .catch(error => {
                            self.errorMessage =
                                error.response.data.ExceptionMessage;
                            setTimeout(function() {
                                self.errorMessage = '';
                            }, 5000);
                        })
                        .finally(() => {
                            self.processing = false;
                            setTimeout(function() {
                                self.responseMsg = '';
                            }, 5000);
                        });
                } else {
                    window.scrollTo(0, 0);
                    self.error = true;
                    self.errorMessage =
                        'Controleer jouw invoer, mogelijk zijn er verplichte velden niet ingevuld of zijn er velden niet correct ingevuld.';
                    self.processing = false;
                }
            });
        }
    }
};
</script>
